<form id="permanent_planning_storecheck_duplicate" [formGroup]="this.permanentPlanningStoreCheckDuplicateForm" (ngSubmit)="this.duplicate()">
    
    <div class="title_card">{{'DUPLICATE_STORECHECK' | translate}}</div>   
    
    @if(this.storeCheck){        
        <div id="permanent_planning_storecheck_duplicate_form">
            <marv-input-date 
                label="{{ 'DAY' | translate }}" 
                formName="day"            
                [fixedLabel]="true"      
                [withSpeechToText]="true" 
                />  
        </div>
    }
    
    <ion-grid id="footer_permanent_planning_storecheck_duplicate">
        <ion-row class="ion-justify-content-around">
            <ion-col size="auto">
                <marv-button type="submit" label="{{ 'VALIDATE' | translate }}" icon="duplicate-outline" color="primary" [isFetching]="this.isFetchingDuplicate"/>
            </ion-col>
            <ion-col size="auto">
                <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancel()" />
            </ion-col>
        </ion-row>
    </ion-grid>
    
</form>